// State/Province OptionSet values — sourced from SUPPLIER_PORTAL_BRIEF.md §9.
// US codes start with 908810 except DC (871840014). CA codes start with 871840.

export type Country = "United States" | "Canada";

export interface StateOption {
  label: string;
  value: number;
  country: Country;
}

export const COUNTRIES: Country[] = ["United States", "Canada"];

export const STATES: StateOption[] = [
  { label: "Alabama", value: 908810001, country: "United States" },
  { label: "Alaska", value: 908810002, country: "United States" },
  { label: "Arizona", value: 908810003, country: "United States" },
  { label: "Arkansas", value: 908810004, country: "United States" },
  { label: "California", value: 908810005, country: "United States" },
  { label: "Colorado", value: 908810006, country: "United States" },
  { label: "Connecticut", value: 908810007, country: "United States" },
  { label: "Delaware", value: 908810008, country: "United States" },
  { label: "District of Columbia", value: 871840014, country: "United States" },
  { label: "Florida", value: 908810009, country: "United States" },
  { label: "Georgia", value: 908810010, country: "United States" },
  { label: "Hawaii", value: 908810011, country: "United States" },
  { label: "Idaho", value: 908810012, country: "United States" },
  { label: "Illinois", value: 908810013, country: "United States" },
  { label: "Indiana", value: 908810014, country: "United States" },
  { label: "Iowa", value: 908810015, country: "United States" },
  { label: "Kansas", value: 908810016, country: "United States" },
  { label: "Kentucky", value: 908810017, country: "United States" },
  { label: "Louisiana", value: 908810018, country: "United States" },
  { label: "Maine", value: 908810019, country: "United States" },
  { label: "Maryland", value: 908810020, country: "United States" },
  { label: "Massachusetts", value: 908810021, country: "United States" },
  { label: "Michigan", value: 908810022, country: "United States" },
  { label: "Minnesota", value: 908810023, country: "United States" },
  { label: "Mississippi", value: 908810024, country: "United States" },
  { label: "Missouri", value: 908810025, country: "United States" },
  { label: "Montana", value: 908810026, country: "United States" },
  { label: "Nebraska", value: 908810027, country: "United States" },
  { label: "Nevada", value: 908810028, country: "United States" },
  { label: "New Hampshire", value: 908810029, country: "United States" },
  { label: "New Jersey", value: 908810030, country: "United States" },
  { label: "New Mexico", value: 908810031, country: "United States" },
  { label: "New York", value: 908810032, country: "United States" },
  { label: "North Carolina", value: 908810033, country: "United States" },
  { label: "North Dakota", value: 908810034, country: "United States" },
  { label: "Ohio", value: 908810035, country: "United States" },
  { label: "Oklahoma", value: 908810036, country: "United States" },
  { label: "Oregon", value: 908810037, country: "United States" },
  { label: "Pennsylvania", value: 908810038, country: "United States" },
  { label: "Rhode Island", value: 908810039, country: "United States" },
  { label: "South Carolina", value: 908810040, country: "United States" },
  { label: "South Dakota", value: 908810041, country: "United States" },
  { label: "Tennessee", value: 908810042, country: "United States" },
  { label: "Texas", value: 908810043, country: "United States" },
  { label: "Utah", value: 908810044, country: "United States" },
  { label: "Vermont", value: 908810045, country: "United States" },
  { label: "Virginia", value: 908810046, country: "United States" },
  { label: "Washington", value: 908810047, country: "United States" },
  { label: "West Virginia", value: 908810048, country: "United States" },
  { label: "Wisconsin", value: 908810049, country: "United States" },
  { label: "Wyoming", value: 908810050, country: "United States" },
  { label: "Alberta", value: 871840008, country: "Canada" },
  { label: "British Columbia", value: 871840009, country: "Canada" },
  { label: "Manitoba", value: 871840006, country: "Canada" },
  { label: "New Brunswick", value: 871840003, country: "Canada" },
  { label: "Newfoundland and Labrador", value: 871840001, country: "Canada" },
  { label: "Northwest Territories", value: 871840011, country: "Canada" },
  { label: "Nova Scotia", value: 871840002, country: "Canada" },
  { label: "Nunavut", value: 871840012, country: "Canada" },
  { label: "Ontario", value: 871840005, country: "Canada" },
  { label: "Prince Edward Island", value: 871840013, country: "Canada" },
  { label: "Quebec", value: 871840004, country: "Canada" },
  { label: "Saskatchewan", value: 871840007, country: "Canada" },
  { label: "Yukon", value: 871840010, country: "Canada" },
  // "Other" is a country-agnostic catch-all (some legacy records use it).
  // Listed under both countries so it surfaces regardless of which the
  // supplier has selected.
  { label: "Other", value: 871840015, country: "United States" },
  { label: "Other", value: 871840015, country: "Canada" },
];

export const SERVICE_AREAS = ["North America", "United States Only", "Canada Only"] as const;
